/*  eslint-disable no-unused-vars */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fa1 } from '@fortawesome/free-solid-svg-icons';

function CPState1({ s1Done }) {
  return (
    <div className="CPS1" style={{ backgroundColor: s1Done ? 'green' : null }}>
      <div className="CPS1_A1">
        <FontAwesomeIcon icon={fa1} />
      </div>
      <div className="CPS1_A2">
        Add information
      </div>
    </div>
  );
}

export default CPState1;
/*  eslint-enable no-unused-vars */
